/* ==============================================
 * custom-properties.css
 * GENERATED FILE - DO NOT EDIT MANUALLY
 *
 * Source: client/web/client_modules/shells/react/components/tokens/
 * To regenerate: yarn generate:css-properties
 * ============================================== */

:root {
    /* Palette */
    --black: #000000;
    --grey-dk: #211712;
    --grey: #4d4540;
    --modal-overlay: hsla(234, 18%, 25%, 0.67);
    --grey-lt: #7a7370;
    --placeholder: #a6a3a1;
    --sidebar-hovered: #cfcfd6;
    --grey-xlt: #d4d1cf;
    --button-secondary-dk: #dbd9d9;
    --off-white-md: #ebe8e8;
    --skeleton-grey: #f1f1f1;
    --off-white: #f7f7f7;
    --off-white-transparent: rgba(247, 247, 247, 0);
    --white: #ffffff;
    --dotcom-purple: #660347;
    --plum: #3d3b8a;
    --ai-purple-dk: #4d22a3;
    --ai-purple-primary: #602bcc;
    --company: #514fb8;
    --ai-purple-md: #7744e1;
    --ai-purple-lt: #8b5cf6;
    --ai-purple-xlt: #a378f6;
    --ai-purple-pink: #bb97f6;
    --ai-purple-pink-md: #e2a9ff;
    --tag-purple-dk: #7373c7;
    --plum-bg-dk: #acace1;
    --tag-purple: #c8c8e9;
    --ai-purple-pink-lt: #e6ddf7;
    --plum-lt: #dbdbf2;
    --tag-purple-lt: #ececf8;
    --plum-xlt: #e9e9f6;
    --ai-purple-pink-xlt: #f2eefb;
    --ai-purple-pink-xxlt: #fbfaff;
    --ai-blue: #0c0f32;
    --ai-hover: #0a0d2b;
    --sidebar-primary: #0c0f33;
    --rcfx-sidebar: #1c2c48;
    --rcfx-sidebar-hover: #1c293f;
    --rcfx-sidebar-primary-item: #142034;
    --sidebar-list-loading: #333557;
    --support-hover: #292967;
    --sidebar-secondary: #242854;
    --quote-toolbar-background: #222f3e;
    --quote-toolbar-button-background: #394452;
    --report-navy: #3d405c;
    --navy-bg-new: #333766;
    --secondary-sidebar-hover-blue: #3f4372;
    --navy-dk-new: #404372;
    --navy-bg-active-new: #5c5f87;
    --navy-lt-new: #5977a4;
    --secondary-sidebar-text: #9397ba;
    --focus-blue: #065289;
    --rcfx-sidebar-active: #0c57ad;
    --blue-dk: #337da8;
    --nutshell-pro: #4f86c6;
    --blue: #3b9ed7;
    --dotcom-teal: #62d4ca;
    --report-blue: #61b2de;
    --navy-xlt-new: #94d1fe;
    --tag-blue: #c0e0f2;
    --blue-lt: #d9edf7;
    --list-selected: #e8f4fb;
    --blue-xlt: #e8f4fa;
    --blue-bg-lt: #eff5f7;
    --navy-bg: #f7fafc;
    --info-bg: #eaf5fb;
    --green-50: #f7fcf7;
    --green-100: #ecf9ef;
    --green-200: #d6f2de;
    --green-300: #c4eecc;
    --green-400: #5ccf73;
    --green-500: #33c252;
    --green-600: #2e9942;
    --green-700: #0b8d6c;
    --green-800: #165024;
    --green-900: #113c1b;
    --yellow-50: #fffcf7;
    --yellow-100: #fff8e5;
    --yellow-150: #fff5d9;
    --yellow-200: #fff0c5;
    --yellow-300: #fde9b4;
    --yellow-400: #ffde73;
    --yellow-500: #fac947;
    --yellow-600: #e1b233;
    --yellow-700: #bd9633;
    --yellow-800: #a37d23;
    --yellow-900: #7e6019;
    --orange-dk: #bf4200;
    --orange-attention: #ea7134;
    --orange: #fe5800;
    --tag-orange-dk: #ff7833;
    --quote-signature-orange: #e39138;
    --tag-orange: #ffccb2;
    --orange-lt: #ffdecc;
    --tag-orange-lt: #ffeee5;
    --orange-xlt: #faf0e6;
    --orange-bg: #fff0e9;
    --report-orange-bg: #fff7f5;
    --rose-dk: #bf2436;
    --flash-banner-error-text: hsl(353, 68%, 45%);
    --rose: #ff2e47;
    --report-red: #ff596b;
    --tag-red: #ffb2bb;
    --flash-banner-error-background: hsl(356, 100%, 92%);
    --rose-lt: #ffd6d9;
    --tag-red-lt: #ffe5e7;
    --rose-xlt: #fff7f7;
    --messenger-blue: #3b5998;
    --instagram-pink: #dd2a7b;
    --whatsapp-green: #25d366;
    --whatsapp-green-dk: #075e54;
    --zoom-blue: #0b5cff;
    --google-green: #05ac47;
    --teams-blue: #464eb8;
    --social-twitter: #00aced;
    --social-linkedin: #007bb6;
    --social-foursquare: #ef4b78;
    --social-pinterest: #cb2027;
    --social-youtube: #e52d27;
    --social-flickr: #ff0084;
    --social-vimeo: #aad450;
    --social-google-plus: #dd4b39;
    --social-tumblr: #35465c;
    --social-dribbble: #ea4c89;
    --social-behance: #1769ff;
    --social-delicious: #3399ff;
    --social-hacker-news: #ff6600;
    --social-instagram: #3f729b;
    --social-lastfm: #c3000d;
    --social-reddit: #ff4500;
    --social-twitch: #6441a5;
    --social-vine: #00b488;

    /* Semantic Colors */
    --off-white-dk: var(--off-white-md);
    --plum-dk: var(--plum);
    --plum-bg: var(--plum-xlt);
    --red: var(--rose);
    --red-lt: var(--rose-lt);
    --brown-lt: var(--yellow-150);
    --brown: var(--yellow-200);
    --brown-dk: var(--yellow-700);
    --yellow-bg: var(--yellow-50);
    --yellow-lt: var(--yellow-150);
    --yellow: var(--yellow-500);
    --green-bg: var(--green-50);
    --green-xlt: var(--green-100);
    --green-lt: var(--green-200);
    --green: var(--green-500);
    --green-dk: var(--green-600);
    --navy-lt: var(--blue-lt);
    --blue-bg: var(--blue-lt);
    --navy: var(--blue-dk);
    --navy-dk: var(--blue-dk);
    --warning-bg: var(--yellow-100);
    --warning: var(--orange-dk);
    --upgrade: var(--sidebar-primary);
    --alert-bg: var(--rose-xlt);
    --alert: var(--rose-dk);
    --error: var(--rose);
    --overdue: var(--rose-dk);
    --info: var(--blue-dk);
    --support: var(--plum);
    --success-bg: var(--green-100);
    --success: var(--green-700);
    --label: var(--grey);
    --text-hot: var(--orange);
    --text-accounts: var(--plum);
    --text-contacts: var(--blue-dk);
    --text-users: var(--orange-dk);
    --activity: var(--rose-dk);
    --lead: var(--green-600);
    --lead-hovered: var(--green-700);
    --person: var(--blue-dk);
    --task: var(--yellow-700);
    --product: var(--yellow-700);
    --product-bg: var(--yellow-700);
    --product-bg-hovered: var(--yellow-500);
    --icon-primary-hovered: var(--grey-dk);
    --icon-primary: var(--grey);
    --icon-secondary-dk: var(--grey-lt);
    --icon-secondary: var(--grey-xlt);
    --icon-primary-action: var(--grey-xlt);
    --icon-primary-action-hovered: var(--report-blue);
    --list-hovered: var(--blue-lt);
    --background-hot: var(--orange);
    --banner-border-orange: var(--orange-attention);
    --form-border: var(--grey-xlt);
    --button-secondary: var(--off-white-md);
    --zebra-stripe: var(--off-white);
    --wallboard-red: var(--rose-xlt);
    --sidebar-red: var(--sidebar-primary);
    --tag-grey: var(--grey-xlt);
    --tag-grey-lt: var(--off-white-md);
    --tag-green-lt: var(--green-100);
    --tag-blue-lt: var(--info-bg);
    --tag-blue-dk: var(--blue);
    --tag-grey-dk: var(--grey-lt);
    --tag-red-dk: var(--rose);
    --tag-yellow-lt: var(--yellow-100);
    --tag-yellow: var(--yellow-300);
    --tag-yellow-dk: var(--yellow-500);
    --tag-green: var(--green-300);
    --tag-green-dk: var(--green-400);
    --onboarding-help: var(--company);
    --onboarding-help-lt: var(--tag-purple-dk);
    --onboarding-help-dk: var(--plum);
    --report-green: var(--green-400);
    --report-orange: var(--tag-orange-dk);
    --social-facebook: var(--messenger-blue);
    --social-x: var(--black);
    --social-angel-list: var(--black);
    --social-digg: var(--black);
    --social-github: var(--black);
    --ai-purple-bg: var(--ai-purple-pink-xxlt);
    --ai-purple-border: var(--ai-purple-xlt);
    --ai-purple-box-shadow: var(--ai-purple-pink-lt);
    --ai-purple-gradient-basic-one: var(--ai-purple-lt);
    --ai-purple-gradient-basic-two: var(--ai-purple-primary);
    --ai-purple-gradient-one: var(--ai-purple-pink);
    --ai-purple-gradient-two: var(--ai-purple-lt);
    --ai-purple-gradient-three: var(--ai-purple-primary);
    --ai-purple-gradient-expanded-one: var(--ai-purple-pink-md);
    --ai-purple-gradient-expanded-two: var(--ai-purple-pink);
    --ai-purple-gradient-expanded-three: var(--ai-purple-lt);
    --ai-purple-gradient-expanded-four: var(--ai-purple-primary);
    --ai-purple-gradient-bold-one: var(--ai-purple-pink-md);
    --ai-purple-gradient-bold-two: var(--ai-purple-md);
    --ai-purple-gradient-bold-three: var(--ai-purple-lt);
    --ai-purple-gradient-bold-four: var(--ai-purple-pink-md);
    --ai-purple-gradient-bold-five: var(--ai-purple-lt);
    --ai-purple-gradient-bold-six: var(--ai-purple-md);

    /* Screen Sizes */
    --page-width: 940px;
    --page-content-width: 680px;
    --page-sidebar-width: 220px;
    --page-alternate-sidebar-width: 260px;
    --page-alternate-content-width: 640px;
    --sidebar-width: 202px;
    --nm-sidebar-width: 420px;
    --header-height: 50px;
    --onboard-progress-height-lg: 98px;
    --onboard-progress-height-md: 81px;
    --onboard-progress-height-sm: 69px;
    --screen-xs-max: 767px;
    --screen-sm-min: 768px;
    --screen-sm-max: 991px;
    --screen-md-min: 992px;
    --screen-md-max: 1199px;
    --screen-lg-min: 1200px;
    --show-expanded-sidebar-width: 1200px;

    /* Component Sizes */
    --filter-drawer-width: 220px;
    --report-sidebar-width: 140px;
    --report-container-margin-left: 16px;

    /* Font Sizes */
    --font-huge: 21px;
    --font-big: 17px;
    --font-normal: 15px;
    --font-small: 13px;
    --font-tiny: 12px;

    /* Borders */
    --border-hairline: 1px solid #f1f1f1;

    /* Easing */
    --custom-easing: cubic-bezier(0.23, 1, 0.32, 1);
    --custom-easing-bounce: cubic-bezier(0.175, 0.885, 0.32, 1.275);
    --custom-easing-bounce-short: cubic-bezier(0.18, 0.89, 0.45, 1.06);
}
